__turbopack_context__.v({
  "checklist": "Checklist-module__ktXLnG__checklist",
  "checklistCheckbox": "Checklist-module__ktXLnG__checklistCheckbox",
  "checklistItem": "Checklist-module__ktXLnG__checklistItem",
  "checklistLabel": "Checklist-module__ktXLnG__checklistLabel",
  "checklistList": "Checklist-module__ktXLnG__checklistList",
  "checklistSublist": "Checklist-module__ktXLnG__checklistSublist",
  "checklistText": "Checklist-module__ktXLnG__checklistText",
  "checklistTextChecked": "Checklist-module__ktXLnG__checklistTextChecked",
});
